<template>
  <div class="navbar flex flex-row align-center justify-between">
    <div class="title">
      <!--      导翠门诊管理系统-->
    </div>
    <!-- 顶部菜单 -->
    <div class="right-menu flex flex-row align-center">
      <!-- Ai -->
      <span
        class="option-icon cursor-pointer flex align-center justify-center"
        @click="fullScreen()"
      >
        <img
          class="ai-icon"
          src="@/assets/list/ai.png"
          alt="ai"
        >
      </span>
      <!-- 全屏 -->
      <span
        class="option-icon cursor-pointer flex align-center justify-center"
        @click="fullScreen()"
      >
        <img
          class="icon"
          src="@/assets/list/fullScreen.png"
          alt="ai"
        >
      </span>
      <!-- 首页 -->
      <span
        class="option-icon cursor-pointer flex align-center justify-center"
        @click="home()"
      >
        <img
          class="icon"
          src="@/assets/list/home.png"
          alt="ai"
        >
      </span>
      <!-- 退出 -->
      <span
        class="option-icon cursor-pointer flex align-center justify-center"
        @click="logout()"
      >
        <img
          class="icon"
          src="@/assets/list/poweroff.png"
          alt="ai"
        >
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      isFullScreen: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  methods: {
    // 图标1 - 全屏
    fullScreen() {
      if (!this.isFullScreen) {
        // documentElement 属性以一个元素对象返回一个文档的文档元素
        const el = document.documentElement
        el.requestFullscreen || el.mozRequestFullScreen || el.webkitRequestFullscreen || el.msRequestFullScreen
          ? el.requestFullscreen() || el.mozRequestFullScreen() || el.webkitRequestFullscreen() || el.msRequestFullscreen() : null
        this.isFullScreen = true
      } else {
        if (document.exitFullScreen) {
          document.exitFullScreen()
          this.isFullScreen = false
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
          this.isFullScreen = false
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
          this.isFullScreen = false
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
          this.isFullScreen = false
        }
      }
    },
    // 主页
    home() {
      this.$router.push({
        path: '/base/home'
      })
    },
    // 个人信息
    userInfo() {
      const user = {
        name: "个人信息",
        url: "/base/user"
      }
      this.$store.dispatch('tagsView/addView', user)
      this.$router.push({
        path: '/base/user'
      })
    },
    // 左侧菜单
    toggleSideBar() {
      // 设置左侧菜单隐藏
      this.$store.dispatch('app/toggleSideBar')
    },
    // 退出
    logout() {
      const $this = this
      // 清楚缓存
      this.$store.dispatch('clear')
      // 跳转
      $this.$router.push(`/dc/admin/login`)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~@/styles/variables.scss";

.navbar {
  height: 50px;
  line-height: 50px;
  background-color: $topBG;
  color: #ffffff;
  overflow: hidden;

  .title {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: bolder;
    font-size: 20px;
    color: #1D2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
}

.right-menu {
  padding-right: 12px;

  .option-icon {
    margin-right: 8px;

    .icon {
      width: 16px;
      height: 16px;
    }

    .ai-icon {
      width: 48.95px;
      height: 29px;
    }
  }
}
</style>
